<template>
<v-container style="max-width: 1200px; min-width: 200px;">
  <v-row
    v-for="i in numPages"
    :key="i"
    :id="`content_page_${String(i)}`"
    no-gutters
    >
    <v-col v-if="refresh==0">
      <v-card class="ma-1 fill-height">
        <v-responsive :aspect-ratio="210 / 297">
            <pdf :src="pdf_src" :page="i" resize :numPages.sync="numPages"></pdf>
        </v-responsive>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>
<script>
import {debug} from "@/api/logging"
import pdfvuer from "@/components/Pdfvuer"
export default {
  created() {
    this.$store.subscribe((mutation)=>{
      if(mutation.type == 'set_locale') {
        const locale = mutation.payload
        debug('locale', locale)
        this.locale = locale
        this.refresh = 1
        this.$nextTick(() => {
          this.refresh = 0
        })
      }
    })
  },
  computed: {
    pdf_src() {
      // return '/images/es/manual.pdf'
      if(this.locale == 'en') {
        return '/images/es/TAC_Tutorial_en_us.pdf'
      }
      else if(this.locale == 'zh-CN') {
        return '/images/es/TAC_Tutorial_zh_cn.pdf'
      }
      else {
        return '/images/es/TAC_Turtoial_zh_tw.pdf'
      }
    }
  },
  data() {
    return {
      locale: this.$i18n.locale,
      numPages: 1,
      refresh: 0,
    }
  },
  components: {
    pdf: pdfvuer,
  },
}
</script>
